<template>
  <div v-editable="props.stepData" class="step-product" :data-nextstep="props.stepData.nextStep">
    <Suspense>
      <component
        :is="props.stepData.productSelection"
        ref="productSelectorRef"
        :key="props.stepData.productSelection"
        :auth-token-context="wizco.authTokenContext"
        :decision-contexts
        :customer-status="wizco.customerStatus"
        :show-navigation="false"
        :inital-client-data-jwt="actualStepdataRelation.data[props.stepData.fieldKey]"
        @submit="submitProducts"
        @error="showErrorMessage"
      />
      <template #fallback>
        <LoadingSpinner />
      </template>
    </Suspense>
    <StepFooter
      :error-message="showErrors ? productSelectorRef?.errorMessage : null"
      @click="nextStepBtnClick"
    />
  </div>
</template>

<script setup>
import { computed, shallowRef, useTemplateRef, watchEffect } from 'vue'
import StepFooter from '../components/footer/StepFooter.vue'
import { useWizcoStore } from '../stores/wizco'
import LoadingSpinner from '../components/LoadingSpinner.vue'
import { useAlert } from '../composable/useAlert'
import { ERROR_MESSAGES } from '../utils/constants'

const props = defineProps({
  stepData: {
    type: Object,
    required: true
  },
  stepUuid: {
    type: String,
    required: false,
    default: ''
  }
})

const productSelectorRef = useTemplateRef('productSelectorRef')

const wizco = useWizcoStore()
const actualStepdataRelation = wizco.stepData[props.stepUuid]

const decisionContexts = computed(() => {
  return wizco.decisionContexts
    ? wizco.decisionContexts[props.stepData.productSelection]
    : undefined
})

watchEffect(() => {
  wizco.isStepLoading = !!productSelectorRef.value?.isLoading
})

watchEffect(() => {
  if (productSelectorRef.value?.disableSubmitButton === undefined) {
    wizco.isActiveStepReady = false
    return
  }
  wizco.isActiveStepReady = !productSelectorRef.value.disableSubmitButton
})

watchEffect(() => {
  if (productSelectorRef.value?.decisionJwt) {
    actualStepdataRelation.data[props.stepData.fieldKey] = productSelectorRef.value?.decisionJwt
  }
})

const showErrors = shallowRef(false)
const nextStepBtnClick = () => {
  showErrors.value = true
  if (wizco.isActiveStepReady) {
    productSelectorRef.value.submit()
  }
}

const submitProducts = ({ jwt }) => {
  actualStepdataRelation.data[props.stepData.fieldKey] = jwt
  wizco.submit()
}

const showErrorMessage = () => {
  useAlert().log(ERROR_MESSAGES.product)
}
</script>
